import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ConfirmationType } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/WithdrawalPendingRow/WithdrawalPendingRow.state';
import {
    ConfirmationContainer,
    CheckIconWrapper,
    TrashIconWrapper,
    WatchIconWrapper,
    TextContainer,
    TextHeader,
    TextDetails,
    CloseIconWrapper,
} from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/ConfirmationInfo/ConfirmationInfo.style';

interface ConfirmationInfoType {
    type: ConfirmationType;
    onClick: () => void;
}
export const ConfirmationInfo = observer(
    'ConfirmationInfo',
    (props: ConfirmationInfoType): React.ReactElement | null => {
        const { type, onClick } = props;

        if (type === 'approve') {
            return (
                <ConfirmationContainer>
                    <CheckIconWrapper />
                    <TextContainer>
                        <TextHeader>Withdrawal request has been accepted.</TextHeader>
                        <TextDetails>Moved to processed</TextDetails>
                    </TextContainer>
                    <CloseIconWrapper onClick={onClick} />
                </ConfirmationContainer>
            );
        } else if (type === 'reject') {
            return (
                <ConfirmationContainer>
                    <TrashIconWrapper />
                    <TextContainer>
                        <TextHeader>Withdrawal request has been rejected.</TextHeader>
                        <TextDetails>Moved to processed</TextDetails>
                    </TextContainer>
                    <CloseIconWrapper onClick={onClick} />
                </ConfirmationContainer>
            );
        } else if (type === 'review') {
            return (
                <ConfirmationContainer>
                    <WatchIconWrapper />
                    <TextContainer>
                        <TextHeader>Withdrawal request will be reviewed again in 30 days.</TextHeader>
                        <TextDetails>Moved to processed but will return to pending after the 30 days</TextDetails>
                    </TextContainer>
                    <CloseIconWrapper onClick={onClick} />
                </ConfirmationContainer>
            );
        } else {
            return null;
        }
    }
);
